import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import BackButton from '../../../../components/UI/BackButton';
import { translate, newObj } from '../../../../utils/util';
import * as actionInventory from '../../../../actions/inventoryAction';
import ButtonUI from '../../../../components/UI/ButtonUI';
import { onValueChange } from '../../../../utils/handleChangeHooks';
import SelectNew from '../../../../components/UI/SelectNew';
import { Collapsible } from '../../../../components/UI/ComponentsUI';
import InventoryService from '../../../../services/InventoryService';
import ListLotItemsGeneral from '../Lot/ListLotItems/ListLotItemsGeneral';
import { checkPermission } from '../../../../services/auth';
import { PERMISSIONS } from '../../../../utils/constants';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

const AdvancedFilter = (props) => {
    const secondCount = props.history?.location?.state?.secondCount;
    const [lotsUser, setLotsUser] = useState();
    const [refresh, setRefresh] = useState(0);
    const [drops, setDrops] = useState({ areas: [], streets: [], levels: [] });
    const [filter, setFilter] = useState({
        areas: props.filter?.areas || [],
        streets: props.filter?.streets || [],
        levels: props.filter?.levels || [],
        position: props.filter?.position || "",
        orderByPosition: props.filter?.orderByPosition || ""
    });
    const [visibleLotItems, setVisibleLotItems] = useState(false);
    const [allLots, setAllLots] = useState(
        !checkPermission(props.filter.typeInventory === 'G' ? PERMISSIONS.Inventory.General.ConnectLotUser : PERMISSIONS.Inventory.Rotative.ConnectLotUser)
            ? true
            : props.filter.allLots
    );

    useEffect(() => {
        props.getLotsByUser({
            inventoryId: props.inventory.id,
            secondCount: secondCount
        }, (data) => {
            var obj = newObj(lotsUser);
            obj.areas = data.areas;
            obj.streets = data.streets;
            obj.levels = data.levels;
            obj.position = data.position;

            drops.areas = data.areas ? data.areas.map((i) => {
                return { id: i, text: i };
            }) : [];

            drops.streets = data.streets ? data.streets.map((i) => {
                return { id: i, text: i };
            }) : [];

            drops.levels = data.levels ? data.levels.map((i) => {
                return { id: i, text: i };
            }) : [];

            setDrops({ ...drops })
            setLotsUser(obj);
            applyFilter()
        })
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        props.filter.lotItemId = undefined;
        props.filter.inventoryId = props.inventory.id;
        props.filter.startedBy = props.user.userName;
        props.filter.secondCount = secondCount;
        props.setFilterLot(props.filter);
        // setVisibleLotItems(true);
        // eslint-disable-next-line
    }, [refresh]);


    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const applyFilter = () => {
        setRefresh(refresh + 1);
        setVisibleLotItems(false);
        props.filter.inventoryId = props.inventory.id;
        props.filter.areas = filter.areas;
        props.filter.streets = filter.streets;
        props.filter.position = filter.position;
        props.filter.orderByPosition = filter.orderByPosition;
        props.filter.levels = filter.levels;
        props.filter.startedBy = props.user.userName;
        props.filter.secondCount = secondCount;
        props.setFilterLot(props.filter);
        setVisibleLotItems(true);
    };

    const onChangeSelect = (event) => {
        const selectedOptions = event.currentTarget.selectedOptions;
        let finalFilter = {};
        Object.assign(finalFilter, filter);
        if (selectedOptions.length > 0) {
            finalFilter[event.currentTarget.id] = Array.from(selectedOptions).map(x => x.value)
        } else {
            finalFilter[event.currentTarget.id] = [];
        }

        setFilter(finalFilter);
    };

    const onClick = (set) => {
        setAllLots(set);
        props.selectedFilterLotAll(set);
        applyFilter();
    };

    const addAreasAll = (item) => {
        if (item) {
            let finalFilter = {};
            Object.assign(finalFilter, filter);
            finalFilter.areas.push(item);
            setFilter(finalFilter);
        }
    };

    const addStreetAll = (item) => {
        if (item) {
            let finalFilter = {};
            Object.assign(finalFilter, filter);
            finalFilter.streets.push(item);
            setFilter(finalFilter);
        }
    };

    const addLevelsAll = (item) => {
        if (item) {
            let finalFilter = {};
            Object.assign(finalFilter, filter);
            finalFilter.levels.push(item);
            setFilter(finalFilter);
        }
    };

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <div className="row">
                    <div className="title">
                        <i className="mdi mdi-clipboard-check-outline" />
                        {translate('inventory', 'inventory')}
                    </div>
                    {/* <div className="subtitle">
                        | <i className="mdi mdi-alpha-g-circle-outline" />
                        {props.filter.typeInventory === 'G' ? translate('menu.general', 'inventory') : translate('menu.rotative', 'inventory')}
                    </div> */}
                    <div className="subtitle">
                        | <i className="mdi mdi-numeric-2-box-outline" />
                        {secondCount ? translate('general.secondCount', 'inventory') : translate('general.filterAdvanced', 'inventory')}
                    </div>
                    {
                        secondCount &&
                        <>
                            {
                                checkPermission(props.filter.typeInventory === 'G' ? PERMISSIONS.Inventory.General.ConnectLotUser : PERMISSIONS.Inventory.Rotative.ConnectLotUser)
                                && (
                                    <div className="title" style={{ float: 'right', margin: '10px' }}>
                                        <Link
                                            className="row"
                                            to={{
                                                pathname: '../filter/zone',
                                                state: {
                                                    secondCount: true
                                                }
                                            }}
                                            style={{ display: 'block', marginBottom: '0px' }}
                                        >
                                            <i className="material-icons">group</i>
                                        </Link>
                                    </div>
                                )
                            }
                            {
                                checkPermission(props.filter.typeInventory === 'G' ? PERMISSIONS.Inventory.General.ConnectLotUser : PERMISSIONS.Inventory.Rotative.ConnectLotUser)
                                && (
                                    <div className="title" style={{ float: 'right', margin: '10px' }}>
                                        <i className="material-icons" style={{ cursor: 'pointer' }} onClick={() => onClick(allLots ? false : true)}>{allLots ? 'visibility' : 'visibility_off'} </i>
                                    </div>
                                )
                            }
                        </>
                    }
                </div>
            </div>
            <div className="container" style={{ marginTop: '40px' }}>
                <Collapsible
                    id="collapsible2"
                    header={translate('expedition:picking.filter')}
                    body={
                        <>
                            <div className="row">
                                <div className="no-padding col s6">
                                    <SelectNew
                                        id='areas'
                                        name='areas'
                                        display="areas"
                                        label="Área"
                                        data={drops.areas}
                                        multiple
                                        value={filter.areas}
                                        disablePlaceHoderSelect={true}
                                        placeHolder={translate('general:choose-one-option')}
                                        change={onChangeSelect}
                                        changeAll={addAreasAll}
                                        clearAll={() => {
                                            let finalFilter = {};
                                            Object.assign(finalFilter, filter);
                                            filter.areas = [];
                                            setFilter(filter);
                                        }}
                                    />
                                </div>
                                <div className="no-padding col s6">
                                    <SelectNew
                                        id='streets'
                                        name='streets'
                                        display="streets"
                                        label="Rua"
                                        multiple
                                        value={filter.streets}
                                        disablePlaceHoderSelect={true}
                                        data={drops.streets}
                                        change={onChangeSelect}
                                        changeAll={addStreetAll}
                                        clearAll={() => {
                                            let finalFilter = {};
                                            Object.assign(finalFilter, filter);
                                            filter.streets = [];
                                            setFilter(filter);
                                        }}
                                    />
                                </div>
                                <div className="no-padding col s6">
                                    <SelectNew
                                        id='levels'
                                        name='levels'
                                        display="levels"
                                        label="Nivel"
                                        multiple
                                        value={filter.levels}
                                        disablePlaceHoderSelect={true}
                                        data={drops?.levels}
                                        change={onChangeSelect}
                                        changeAll={addLevelsAll}
                                        clearAll={() => {
                                            let finalFilter = {};
                                            Object.assign(finalFilter, filter);
                                            filter.levels = [];
                                            setFilter(filter);
                                        }}
                                    />
                                </div>
                                <div className="no-padding col s6">
                                    <SelectNew
                                        id='orderByPosition'
                                        name='orderByPosition'
                                        label="Ordenação"
                                        value={filter.orderByPosition || ""}
                                        data={[{ id: "ASC", text: translate('positionFilter.asc', 'inventory') },
                                        { id: "DESC", text: translate('positionFilter.desc', 'inventory') }
                                        ]}
                                        change={onChange}
                                    />
                                </div>
                                <div className="no-padding col s6">
                                    <SelectNew
                                        id='position'
                                        name='position'
                                        label="Lado"
                                        value={filter.position || ""}
                                        data={[{ id: "0", text: translate('positionFilter.both', 'inventory') },
                                        { id: "P", text: translate('positionFilter.par', 'inventory'), },
                                        { id: "I", text: translate('positionFilter.impar', 'inventory') }
                                        ]}
                                        change={onChange}
                                    />
                                </div>
                            </div>
                            <div className="row" style={{ marginBottom: '10px' }}>
                                <ButtonUI full="true" onClick={() => applyFilter()} text={translate('apply', 'general')} />
                            </div>
                        </>
                    }
                />
            </div>
            {visibleLotItems &&
                <ListLotItemsGeneral advancedFilter={true}
                    refredhAdvancedFilter={refresh}
                    secondCount={secondCount}
                />
            }
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        filter: state.inventoryReducer.filter,
        inventory: state.inventoryReducer.inventory,
        user: state.userReducer.user,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getLotsByUser: (filter, callback) => {
            dispatch(InventoryService.getLotsByUser(filter, callback));
        },
        setFilterLot: (filter) => {
            dispatch(actionInventory.selectLotInventory(filter));
        },
        selectedFilterLotAll: (allLots) => {
            dispatch(actionInventory.setSelectedFilterLotAll(allLots));
        },
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(AdvancedFilter)));
